import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "NavigationBar" }
const _hoisted_2 = ["title", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass([
					'NavigationItem',
					{ 'IsActive': _ctx.isPathActive(item.path) }
				]),
          title: item.label,
          onClick: ($event: any) => (_ctx.navigateToPage(item.path))
        }, _toDisplayString(item.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}